import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import TestimonyProgramContain from '../TestimonyProgramContain';

const TestimonyProgramContainer = ({ setRefetch }) => {
  return (
    <Fragment>
      <Container fluid={true}>
        <div>
          <Row className="product-page-main p-0">
            <TestimonyProgramContain setRefetch={setRefetch} />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default TestimonyProgramContainer;